import { THEME_COLORS } from '@st/theme/colors'
import { Rect } from '@st/geom'
import { StampTemplate, TextStampTemplateSection } from '~/st-doc-viewer/annotations'
import { recomputeStampLayoutAndStyle } from '../stamps-core/stamp-layout'
import { StampAnnotation } from '@st/sdk'

const RED = THEME_COLORS['red'][600]
const YELLOW = THEME_COLORS['yellow'][300]

const ZERO_RECT: Rect = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
}

type ReferenceStamp = { text: string; label: string; stampCode: string }

const REFERENCES: ReferenceStamp[] = [
  { text: 'R-1', stampCode: 'R-1', label: 'Reference 1' },
  { text: 'R-2', stampCode: 'R-2', label: 'Reference 2' },
  { text: 'R-3', stampCode: 'R-3', label: 'Reference 3' },
  { text: 'R-4', stampCode: 'R-4', label: 'Reference 4' },
  { text: 'R-5', stampCode: 'R-5', label: 'Reference 5' },
  { text: 'R-6', stampCode: 'R-6', label: 'Reference 6' }
]

export const REFERENCE_STAMP_TEMPLATE_SECTIONS: TextStampTemplateSection[] = [
  {
    title: 'References',
    layout: 'rows',
    templates: REFERENCES.map(({ text, stampCode, label }) => ({
      id: text,
      label: label,
      category: 'cross_reference',
      annotation: recomputeStampLayoutAndStyle({
        id: text,
        text: text,
        time: '2000-01-01T00:00:00.000Z',
        stampType: 'cross_reference',
        stampCode: stampCode,
        stampSize: 20,
        color: RED,
        backgroundColor: YELLOW,
        bounds: ZERO_RECT,
        type: 'stamp',
        pageNumber: 1,
        font: {
          family: 'Helvetica',
          size: -1,
          weight: 'normal'
        }
      })
    }))
  }
]

export function findMatchingTemplate(
  annotation: StampAnnotation | undefined
): StampTemplate | undefined {
  if (!annotation) {
    return undefined
  }

  for (const section of REFERENCE_STAMP_TEMPLATE_SECTIONS) {
    for (const template of section.templates) {
      if (templateMatches(template, annotation)) {
        return template
      }
    }
  }

  function templateMatches(template: StampTemplate, annotation: StampAnnotation) {
    return (
      template.annotation.stampCode == annotation.stampCode &&
      template.annotation.stampType == annotation.stampType
    )
  }
}
